import React from 'react';
import styles from './LeagueAwards.module.css';

const AWARD_CATEGORIES = [
    { key: 'mostWins', title: 'Najwięcej wygranych', icon: '\u{1F3C6}', color: '#FFD700' },
    { key: 'longestWinStreak', title: 'Najdłuższa seria', icon: '\u{1F525}', color: '#FF6B35' },
    { key: 'bestGameBalance', title: 'Bilans gemów', icon: '\u{1F4CA}', color: '#388eea' },
    { key: 'highestWinPercentage', title: 'Najwyższy % wygranych', icon: '\u{1F3AF}', color: '#E74C3C' },
    { key: 'bestSetBalance', title: 'Bilans setów', icon: '\u{1F4C8}', color: '#2ECC71' },
    { key: 'mostTiebreaksWon', title: 'Wygrane tiebreaki', icon: '\u{26A1}', color: '#9B59B6' },
    { key: 'mostDominant', title: 'Najbardziej dominujący', icon: '\u{1F4AA}', color: '#E67E22' },
    { key: 'comebackKing', title: 'Król powrotów', icon: '\u{1F451}', color: '#F1C40F' },
    { key: 'warrior', title: 'Wojownik', icon: '\u{2694}\u{FE0F}', color: '#95A5A6' },
];

const MEDALS = ['\u{1F947}', '\u{1F948}', '\u{1F949}'];

const LeagueAwards = ({ awards }) => {
    if (!awards) return null;

    const visibleCategories = AWARD_CATEGORIES.filter(
        (cat) => awards[cat.key] && awards[cat.key].length > 0
    );

    if (visibleCategories.length === 0) return null;

    return (
        <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Wyróżnienia Ligowe</h3>
            <div className={styles.grid}>
                {visibleCategories.map((cat) => {
                    // Grupujemy wpisy po randze (gęsty ranking z backendu) — remisujący
                    // (ta sama wartość) trafiają pod jeden medal.
                    const places = [];
                    awards[cat.key].forEach((entry) => {
                        // Defensywnie pomijamy wpisy bez nazwiska (inaczej renderują się jako sam przecinek).
                        if (!entry.playerName || !entry.playerName.trim()) return;
                        let place = places.find((p) => p.rank === entry.rank);
                        if (!place) {
                            place = { rank: entry.rank, value: entry.formattedValue, players: [] };
                            places.push(place);
                        }
                        place.players.push(entry);
                    });
                    places.sort((a, b) => a.rank - b.rank);

                    return (
                        <div
                            key={cat.key}
                            className={styles.card}
                            style={{ borderTopColor: cat.color }}
                        >
                            <div className={styles.cardHeader}>
                                <span className={styles.cardIcon}>{cat.icon}</span>
                                <span className={styles.cardTitle}>{cat.title}</span>
                            </div>
                            <ul className={styles.entryList}>
                                {places.map((place) => (
                                    <li key={place.rank} className={styles.placeRow}>
                                        <span className={styles.medal}>
                                            {MEDALS[place.rank - 1] || ''}
                                        </span>
                                        <span className={styles.placeValue}>{place.value}</span>
                                        <span className={styles.placeNames}>
                                            {place.players.map((p, i) => (
                                                <React.Fragment key={p.participantId}>
                                                    {i > 0 && ', '}
                                                    {p.playerName}
                                                    {p.partnerName && ` / ${p.partnerName}`}
                                                    {p.currentGroup && (
                                                        <span className={styles.playerGroup}>
                                                            {' '}({p.currentGroup})
                                                        </span>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LeagueAwards;
